// Lightweight GA4 event helper.
// Measurement ID is loaded via <script> in public/index.html.
// Events are no-ops if gtag isn't available (SSR, ad-blocker, dev).

export const GA_ID = "G-ZR0ZQJXKRQ";

export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (_) {
    /* silent */
  }
};
